<template>
  <div>
    <v-dialog class="new-event-dialog" :title="dialogTitle" :visible.sync="viewEventDialogVisible"
      :modal-append-to-body="false" width="auto" @open="onOpen" @closed="onClosed">
      <div class="padding-lr">
        <el-form>
          <el-row type="flex" :gutter="50">
            <el-col :span="11">
              <el-form-item label="Subject">
                <el-input v-model="form.input" disabled placeholder="Subject">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" :gutter="50">
            <el-col class="date-time" :span="12">
              <el-form-item label="Start Datetime">
                <el-date-picker class="date-picker" disabled v-model="form.startDateTime" value-format="yyyy-MM-dd"
                  type="date" placeholder="Select date" :editable="false" :clearable="false" />
              </el-form-item>
              <el-form-item>
                <el-time-select class="time-selecter" disabled v-model="startSelectTime" :editable="false"
                  placeholder="Select period" value-format="HH:mm" :clearable="false" ref="startTime" />
              </el-form-item>
            </el-col>
            <el-col class="date-time" :span="12">
              <el-form-item label="End Datetime">
                <el-date-picker class="date-picker" disabled v-model="form.endDateTime" value-format="yyyy-MM-dd"
                  type="date" placeholder="Select date" :editable="false" :clearable="false" />
              </el-form-item>
              <el-form-item>
                <el-time-select class="time-selecter" disabled v-model="endSelectTime" :editable="false"
                  placeholder="Select period" value-format="HH:mm" :clearable="false" ref="startTime" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" :gutter="50">
            <el-col :span="24">
              <el-form-item label="Description">
                <el-input v-model="form.content" type="textarea" :rows="4">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="table-wrapper">
          <el-table :data="seList">
            <el-table-column prop="Name" label="SE/CE Name" min-width="100" />
            <el-table-column prop="City" label="City" min-width="90" />
            <el-table-column prop="Hospital" label="Hospital / Institution" min-width="180" />
            <el-table-column prop="Department" label="Department" min-width="110" />
            <el-table-column prop="MLName" label="MSL Name" min-width="120" />
            <el-table-column prop="TeamName" label="Team" min-width="80" />
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onClosed"> close </el-button>
      </div>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "view-event-dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: {},
  },
  data() {
    return {
      viewEventDialogVisible: this.visible,

      endSelectTime: "",
      startSelectTime: "",
      startDatetime: "",
      form: {
        input: "",
        startDateTime: "",
        endDateTime: "",
        content: "",
      },
      selectSeDialogVisible: false,
      seList: [],
      content: "",
    };
  },
  watch: {
    visible(value) {
      this.viewEventDialogVisible = value;
    },
    startDateTime(value) {
      this.form.startDatetime =
        value && this.startSelectTime ? `${value}${this.startSelectTime}` : "";
    },
    startSelectTime(value) {
      this.form.startDatetime =
        value && this.startDateTime ? `${this.startDateTime}${value}` : "";
    },
  },
  methods: {
    onOpen() {
      if (this.data) {
        this.$nextTick(() => {
          this.form.input = this.data.Subject;
          this.form.startDateTime = this.data.StartDateTime;
          this.form.endDateTime = this.data.EndDateTime;
          this.form.content = this.data.content;
          this.startSelectTime = this.data.StartDateTime.split(
            "T"
          )[1].substring(0, 5);
          this.endSelectTime = this.data.EndDateTime.split("T")[1].substring(
            0,
            5
          );
        });
      }
      this.getSEList();
    },
    getSEList() {
      let params = {
        actId: this.data.ActivityID,
      };
      this.axios
        .get(`/event/getSe`, { params: params })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.seList = data;
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        });
    },
    onClosed() {
      this.$emit("update:visible", false);
    },
  },
  computed: {
    dialogTitle() {
      return `Event Information`;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    padding: 0px;
    display: flex;
    max-height: 70vh;
  }
}

.view-event-dialog {

  // width: 800px;
  .el-form {
    padding: 0 60px;
    margin-bottom: 20px;

    h4 {
      margin-bottom: 5px;
    }

    .el-form-item {
      &:not(.no-mt) {
        margin-bottom: 10px !important;
      }

      &.no-mb {
        margin-bottom: 0 !important;
      }

      .el-form-item__label {
        padding: 0;
      }

      &.cate {
        .el-radio-group {
          display: flex;
          padding: 4px 0;
        }
      }
    }

    .el-form-item.request-type {
      .el-radio {
        display: block;
        line-height: 32px;
      }
    }

    .tinymceEditor {
      margin-bottom: 10px;
    }
  }

  .el-row {

    &.greetings-settings,
    &.request-type {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }

    &.request-type {
      margin-top: 10px;
      padding: 30px 0;
      background-color: #f4f7f9;
    }

    .el-col.settings {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .el-col.date-time {
      display: flex;
      align-items: flex-end;

      .el-date-editor {
        min-width: 130px;
        width: 100% !important;
      }

      .el-form-item {
        &:first-child {
          margin-right: 5px;
        }
      }
    }

    .description {
      padding: 8px 0px;
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
}
</style>
